/*
  Xeridas WhatsApp orders (snippets/buy-buttons.liquid, theme setting
  "Order through WhatsApp"). On click, the link's href is rebuilt with the
  presentation and quantity selected at that moment, read from the product
  form's variant input (kept current by Dawn's product-info.js) and the
  quantity input. The browser then follows the updated href.
*/
(function () {
  if (window.__xeridasWhatsappOrder) return;
  window.__xeridasWhatsappOrder = true;

  function message(link) {
    const form = link.closest('form');
    const data = form && form.querySelector('[data-wa-variants]');
    if (!data) return null;

    let product;
    try {
      product = JSON.parse(data.textContent);
    } catch (error) {
      return null;
    }

    const variantId = form.querySelector('input[name="id"]')?.value;
    const variant = product.variants[variantId];
    const scope = link.closest('product-info') || document;
    const quantity = parseInt(scope.querySelector('.quantity__input')?.value, 10) || 1;

    const lines = ['Hola, me gustaría hacer un pedido de Xeridas Coffees:', `Producto: ${product.title}`];
    if (variant && !product.single) lines.push(`Presentación: ${variant.title}`);
    lines.push(`Cantidad: ${quantity}`);
    if (variant) lines.push(`Precio unitario: ${variant.price}`);
    lines.push(variantId ? `${product.url}?variant=${variantId}` : product.url);
    return lines.join('\n');
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest && event.target.closest('[data-wa-order]');
      if (!link) return;
      const text = message(link);
      if (text) link.href = `https://wa.me/${link.dataset.waNumber}?text=${encodeURIComponent(text)}`;
    },
    true
  );
})();
